<template>
  <div class="forbidden-container">
    <div class="forbidden-content">
      <h1 class="forbidden-code">403</h1>
      <h2 class="forbidden-title">{{ $t('httpStatusMessages.httpStatusTitle403')}}</h2>
      <p class="forbidden-message">
        {{ $t('httpStatusMessages.httpStatusMsg403')}}
      </p>
      <router-link :to="{ name: 'home' }" class="btn-home">
        <i class="bi bi-house-door me-2"></i>
        ホームに戻る
      </router-link>
    </div>
  </div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.forbidden-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 54px);
  background-color: #F2F5F7;
  padding: 24px;
}

.forbidden-content {
  text-align: center;
  max-width: 500px;
}

.forbidden-code {
  font-size: 48px;
  font-weight: 700;
  color: #222222;
  margin: 0;
  line-height: 1;
}

.forbidden-title {
  font-size: 24px;
  font-weight: 600;
  color: #222222;
  margin: 24px 0 16px;
}

.forbidden-message {
  font-size: 16px;
  color: #6B7280;
  margin: 0 0 32px;
  line-height: 1.6;
  white-space: pre-line;
}

.btn-home {
  display: inline-flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #306FC9;
  color: #FFFFFF;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2563EB;
    color: #FFFFFF;
  }
}
</style>
